"use strict";

// Module API

function checkUnique() {
  return true;
}

module.exports = {
  checkUnique: checkUnique
};